import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { AuthService } from 'app/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly _authService: AuthService,
    private readonly _router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    // Required, do not remove: initial navigation and the auth app initializer run
    // concurrently (see appConfig), so this await is what makes routing wait for auth
    // to settle. Without it the guard reads an unauthenticated service on cold start.
    await this._authService.ready;

    if (this._authService.isLoggedIn()) {
      return true;
    }
    this._authService.saveCurrentPathInSession();
    this._router.navigate(['/login']);
    return false;
  }

  async canActivateChild(): Promise<boolean> {
    return this.canActivate();
  }
}
